import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import wo from "../assets/Wo.webp";
import br from "../assets/BR.webp";
import bm from "../assets/BM.webp";
import bbb from "../assets/BB.svg";
import s1 from "../assets/S1.svg";
import s2 from "../assets/S2.svg";
import s3 from "../assets/S3.svg";
import t1 from "../assets/T1.png";
import t2 from "../assets/T2.png";
import t3 from "../assets/T3.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import inst from "../assets/Ins.png";
import user from "../assets/user.png";
import { Helmet } from "react-helmet";

import { useNavigate } from 'react-router-dom'; 
import { useRef } from "react";
import { toast } from "react-toastify";
 

const Edu = () => {
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };

const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
     const [isServicesOpen, setIsServicesOpen] = useState(false);
     const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
     const [isCompanyOpen, setIsCompanyOpen] = useState(false);
   
     const toggleMobileMenu = () => {
       setIsMobileMenuOpen(!isMobileMenuOpen);
     };
   
     const toggleServicesDropdown = () => {
       setIsServicesOpen(!isServicesOpen);
     };
   
     const toggleIndustriesDropdown = () => {
       setIsIndustriesOpen(!isIndustriesOpen);
     };
   
     const toggleCompanyDropdown = () => {
       setIsCompanyOpen(!isCompanyOpen);
     };
   const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };

 const cards = [
  {
    title: "Easy registration & enrollment",
    desc: "Begin your journey by filling out the form, selecting your department, and clicking 'Register' to submit your application.",
    bgImage: s1,
    color: "#5ECC9F",
    text: "text-gray-900",
  },
  {
    title: "Personalized Dashboard",
    desc: "Access your personalized dashboard to explore programs, track your application, manage payments, and receive task reminders.",
    bgImage: s2,
    color: "#0A0A0A",
    text: "text-white",
  },
  {
    title: "Supportive features",
    desc: "We offer tools designed to enhance your learning experience and support your academic success through a seamless, engaging environment.",
    bgImage: s3,
    color: "#CA9BFB",
    text: "text-gray-900",
  },
  {
    title: "Essential academic resources",
    desc: "Our website is your central hub for easy access to academic resources and course updates.",
    bgImage: s2,
    color: "#0A0A0A",
    text: "text-white",
  },
  {
    title: "Bridging theory & Practice",
    desc: "Our courses bridge theory and practice by offering practical training that meets both academic and industry needs.",
    bgImage: s1,
    color: "#5ECC9F",
    text: "text-gray-900",
  },
  {
    title: "Training & Placement opportunities",
    desc: "Our strong support and preparation help students excel in competitive job markets and launch successful, rewarding careers.",
    bgImage: s3,
    color: "#CA9BFB",
    text: "text-gray-900",
  },
];
  const cardClasses =
    "w-[300px] sm:w-[340px] md:w-[360px] lg:w-[380px] xl:w-[400px] rounded-lg p-6 shadow-lg bg-cover bg-center";


 // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
  const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};


const features = [
  {
    icon: t1,
    bg: "bg-[#DFFCF3]",              // soft mint
    title: "Dedicated to you",
    desc:
      "Join our vibrant community where expert mentors support your journey to academic and professional success.",
  },
  {
    icon: t2,
    bg: "bg-[#F4F1FF]",              // pastel lavender
    title: "Impact on industry",
    desc:
      "Lentera links candidates with partners to deliver real‑world training and skill‑building.",
  },
  {
    icon: t3,
    bg: "bg-[#E8FFE9]",              // light green
    title: "Call to action",
    desc:
      "Join Lentera’s thriving learning community to gain the tools and support you need for career growth and success.",
  },
];

const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };


  return (
    <div>
     <Helmet>
        <title>LENTERA education programs, hands-on-training support.</title>
        <meta name="description" content="Empower students with LENTERA’s dynamic education programs. Gain industry-relevant skills, hands-on training, personalized dashboards, and seamless access to resources for academic success and career readiness."/>
        <meta name="keywords" content="LENTERA education programs, hands-on-training support."/>
      </Helmet>
 <section className="w-full bg-[#FFF0EF] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#212129] text-sm font-medium uppercase mb-3 tracking-wide">
        Education
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
           Where learning meets <br /> limitless possibilities 
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
         We provide the tools, guidance, and inspiration to help you unlock  <br/> your full potential and create a future without limits.

      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      
    <img
    src={wo}
    alt="Learning Illustration"
    className=" max-w-[420px] object-contain"
  />
    </motion.div>

  </div>
</section>

     

     
  

   <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-12">
  {/* Top Overview Section */}
  <div className="max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-start gap-6 mb-12">
    {/* Heading */}
    <motion.h2
      className="text-[36px] sm:text-[42px] md:text-[48px] font-extrabold text-[#1A1A1A]"
      initial={{ opacity: 0, x: -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      Overview
    </motion.h2>

    {/* Paragraph */}
    <motion.p
      className="text-[#3D3D3D] text-[16px] md:text-[16px] leading-[28px] max-w-2xl"
      initial={{ opacity: 0, x: 30 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
    >
      Welcome to a dynamic learning space that prepares students for real-world challenges
      and evolving industry needs. Through hands-on teaching and bridging academics with
      business, we build practical skills. Our graduates are ready to succeed in today’s
      competitive professional world.
    </motion.p>
  </div>
   <div className="px-4">
      <div className="bg-[#1E1E1E] rounded-[40px] text-white px-6 md:px-12 py-10 md:py-16 flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
        {/* Left Image */}
       <div className="w-full md:w-1/2 flex justify-center mb-10 md:mb-0">
  <img
    src={br}
    alt="Education Impact Visual"
    className="w-3/4 md:w-[400px] h-auto mr-20"
  />
</div>


        {/* Right Text Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-6">
            Our impact on the <br className="hidden md:block" /> education industry
          </h2>
          <p className="text-sm md:text-base text-gray-300 leading-relaxed">
            Educational institutions can enhance efficiency and provide seamless access to resources by integrating services like content repositories, learning management systems, and student information systems.
          </p>
        </div>
      </div>
    </div>
 
</section>

     <section className="bg-white font-poppins px-6 md:px-12 lg:px-20 py-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
        {/* Left 60% */}
        <div className="w-full lg:w-[60%]">
          {/* Capsule Label */}
          <span className="inline-block bg-[#D6F8CB] text-[#028A0F] text-xs font-semibold px-4 py-1 rounded-full mb-5">
            FOR GREAT FUTURE
          </span>

          {/* Heading */}
          <h2 className="text-[36px] sm:text-[42px] lg:text-[52px] leading-tight font-bold text-[#1A1A1A] mb-6">
            Dynamic learning <br className="hidden sm:block" />
            community, embracing <br className="hidden sm:block" />
            your future
          </h2>

          {/* Description */}
          <p className="text-[16px] text-[#3D3D3D] leading-relaxed">
            We provide practical, comprehensive education to meet today’s industry
            needs. Our programs blend academics with real-world experience.
            Graduates gain skills to succeed in a fast-paced workforce.
          </p>
        </div>

        {/* Right 40% */}
        <div className="w-full lg:w-[40%] flex justify-center">
          <img
            src={bm}
            alt="Learning Illustration"
            className="w-full max-w-md"
          />
        </div>
      </div>
    </section>






    <section className="bg-[#1D1D26] text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Top: Heading & Text */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8">
          <h2 className="text-4xl sm:text-5xl font-semibold leading-tight ml-20">
            Your benefits <br /> with us
          </h2>
          <p className="text-lg sm:text-[16px] text-gray-300 max-w-xl text-left mr-20">
  Experience hands-on learning, industry-relevant skills, and dedicated <br/>
  support that empower you to thrive in the real world.
</p>
        </div>

        {/* Bottom: Centered Image */}
        <div className="mt-16 flex justify-center">
          <img
            src={bbb}
            alt="Benefits illustration"
            className="w-full max-w-5xl h-auto object-contain mr-20"
          />
        </div>
      </div>
    </section>
    <section className="bg-white py-12 px-4">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-1xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">
          Supporting your academic journey
        </h2>

      <p className="mt-6 text-base sm:text-lg md:text-[15px] text-gray-600 leading-normal">
  We provide the guidance, resources, and real-world learning opportunities you need to grow <br/> 
  confidently and succeed at every step of your education.
</p>
      </div>
    </section>



<section className="py-12 px-4 sm:px-6 md:px-8 lg:px-12 bg-white -mt-10">
  <div className="max-w-screen-xl mx-auto flex flex-col items-center space-y-8">

    {/* Row 1 */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {cards.slice(0, 3).map((c, i) => (
        <div
          key={i}
          className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                      flex flex-col justify-center items-center overflow-hidden ${c.text}`}
          style={{ backgroundImage: `url(${c.bgImage})` }}
        >
          <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
          <div className="relative z-10">
            <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
            <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {cards.slice(3, 5).map((c, i) => (
        <div
          key={i + 3}
          className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                      flex flex-col justify-center items-center overflow-hidden ${c.text}`}
          style={{ backgroundImage: `url(${c.bgImage})` }}
        >
          <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
          <div className="relative z-10">
            <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
            <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
          </div>
        </div>
      ))}
    </div>

    {/* Row 3 */}
    <div className="flex justify-center">
      {(() => {
        const c = cards[5];
        return (
          <div
            className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                        flex flex-col justify-center items-center overflow-hidden ${c.text}`}
            style={{ backgroundImage: `url(${c.bgImage})` }}
          >
            <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
            <div className="relative z-10">
              <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
              <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
            </div>
          </div>
        );
      })()}
    </div>

  </div>
</section>


<section className="w-full py-20 px-6 bg-white font-poppins">
      {/* Heading */}
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h2 className="text-[48px] leading-snug font-semibold text-[#1f1f1f]">
          Key features
        </h2>
        <p className="mt-4 text-gray-600">
          Discover the game‑changing key features that set you apart!
        </p>
      </div>

      {/* Feature Cards */}
      <div className="max-w-7xl mx-auto grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {features.map(({ icon, bg, title, desc }, idx) => (
          <div
            key={idx}
            className={`${bg} rounded-[24px] p-8 md:p-10 flex flex-col h-full`}
          >
            <img src={icon} alt={title} className="w-14 h-14 mb-6" />

            <h3 className="text-[22px] font-semibold text-[#1f1f1f] mb-4">
              {title}
            </h3>

            <p className="text-gray-700 leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>
    </section>

     
    
       <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
    <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><Link to="/blogs" className="hover:text-white">Blog</Link></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><Link to="/blogs" className="hover:text-white">News</Link></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>


    </div>
  )
}

export default Edu